<template>
  <section class="grey_bg" aria-labelledby="aml-heading">
    <div class="container mt-4">
      <h1 id="aml-heading" class="mt-4 page-title">ANTI-MONEY LAUNDERING (AML) POLICY</h1>

      <h2 class="mt-4 section-heading">1. Introduction</h2>
      <p>Grow With Stocks (“the Firm”) is a SEBI Registered Individual Research Analyst regulated under the SEBI (Research Analysts) Regulations, 2014, and adheres to the Prevention of Money Laundering Act, 2002 (PMLA) and related Rules.</p>
      <p>This AML/CTF Policy aims to prevent illicit activities such as money laundering, terrorism financing, fraud, and unlawful financial transactions in connection with research and advisory services.</p>

      <h2 class="mt-4 section-heading">2. Scope</h2>
      <p>This policy applies to:</p>
      <ul>
        <li>All fee-paying clients of the Firm</li>
        <li>Digital payment channels used for fee collection</li>
        <li>Client onboarding, renewal, and research service activities</li>
      </ul>
      <p>No research, fee processing, or client-related functions are outsourced.</p>

      <h2 class="mt-4 section-heading">3. Client Due Diligence (CDD)</h2>
      <p>All clients must undergo mandatory due diligence. The Firm collects and verifies:</p>
      <ul>
        <li>Permanent Account Number (PAN)</li>
        <li>Verify client data through KYC Registration Agencies (KRA) such as CVL KRA, NDML KRA, or BSE KRA.</li>
        <li>Mobile Number & Email ID</li>
        <li>Residential/Invoice Address</li>
        <li>Client Consent & Risk Disclosure Confirmation</li>
      </ul>
      <p>No services are activated without completion of CDD and receipt of fees from the registered client’s own bank account.</p>

      <h3 class="aml-subheading">a). Client Identity Screening</h3>
      <p>Grow With Stocks screens client identity against publicly available lists such as:</p>
      <ul>
        <li>SEBI debarred and banned entities (BSE/NSE)</li>
        <li>UN Security Council Sanctions Lists</li>
      </ul>
      <p>Services will not be provided to clients appearing in these lists or where false identity information is suspected.</p>

      <h3 class="aml-subheading">b). Risk Categorization</h3>
      <p>Clients may be classified as Low, Medium, or High Risk based on payment source, jurisdiction, and public reputation. Politically Exposed Persons (PEPs) or clients from highrisk jurisdictions may require additional verification before acceptance. If satisfactory information is not provided, services will not be activated.</p>

      <h3 class="aml-subheading">c). Policy for Acceptance of Clients</h3>
      <p>Grow With Stocks will ensure:</p>
      <ul>
        <li>Services are not activated for fictitious, anonymous or false identity submissions.</li>
        <li>Fees are not accepted in cash or from any third-party account.</li>
        <li>If the Firm is unable to complete identity verification or if any information provided is suspected to be unreliable, service delivery is denied.</li>
        <li>The Firm does not onboard clients whose names appear on SEBI’s debarred list, banned entities list of exchanges, or UN Security Council Sanctions Lists.</li>
        <li>Clients may be categorized as Low, Medium, or High risk based on payment behavior, country of residence and public profile. Higher-risk clients may require additional verification before activation.</li>
      </ul>

      <h2 class="mt-4 section-heading">4. Details of Associates Dealing Through the Firm</h2>
      <p>The Firm has no associates, agents, channel partners, or dealers who transact on behalf of clients.</p>
      <p>All subscriptions are taken directly from clients, with no intermediary involvement.</p>
      <p>This requirement shall apply as and when staff or associates are appointed.</p>

      <h2 class="mt-4 section-heading">5. Other Business Activity</h2>
      <p>Grow With Stocks is exclusively engaged in equity research and investment recommendation services.</p>
      <p>No business is conducted outside the securities research domain.</p>

      <h2 class="mt-4 section-heading">6. Ongoing Monitoring &amp; Continuous Due Diligence</h2>
      <p>The Firm performs ongoing monitoring through:</p>
      <ul>
        <li>Verification of client identity during renewals</li>
        <li>Rejecting payments from mismatched or suspicious sources</li>
        <li>Reviewing new client consents and declarations during renewals</li>
      </ul>

      <h2 class="mt-4 section-heading">7. Periodic Review of Client Data</h2>
      <p>Client information (PAN, contact details, consent, risk disclosures) is reviewed and updated:</p>
      <ul>
        <li>At the time of renewal</li>
        <li>Whenever there is a change in client details</li>
      </ul>
      <p>No extension of service is provided without updated confirmation.</p>

      <h2 class="mt-4 section-heading">8. Beneficial Ownership Verification</h2>
      <p>Fees are accepted only from the bank account of the registered client.</p>
      <ul>
        <li>Third-party payments are strictly prohibited</li>
        <li>If beneficial ownership is claimed, documentary evidence must be provided</li>
        <li>If valid proof is not produced, the transaction is rejected and refunded</li>
      </ul>

      <h2 class="mt-4 section-heading">9. Acceptable and Prohibited Payment Modes</h2>
      <p><b>Accepted</b><br>
      UPI, NEFT, IMPS, Online Bank Transfer, Cheques</p>
      <p><b>Not Accepted</b><br>
      Cash, Payments via Third Parties</p>
      <p>All fees must be received into the official business bank account only.</p>

      <h2 class="mt-4 section-heading">10. Cash/DD Acceptance</h2>
      <p>The Firm has zero tolerance for cash or physical instrument payments.</p>
      <p>No cash or DD payments are accepted under any circumstances.</p>

      <h2 class="mt-4 section-heading">11. In-Person Verification</h2>
      <p>As per SEBI RA framework, physical in-person verification is not mandatory.</p>
      <p>Digital KYC through PAN + Digital consent is conducted.</p>
      <p>Hence, physical IPV is Not Applicable (N/A).</p>

      <h2 class="mt-4 section-heading">12. Third-Party Payments and Receipts</h2>
      <p>Third-party payments are not allowed. If any attempt is made:</p>
      <ul>
        <li>The payment is immediately refunded</li>
        <li>Service is not activated</li>
        <li>A compliance record is maintained</li>
      </ul>
      <p>No third-party transactions have occurred to date.</p>

      <h2 class="mt-4 section-heading">13. Record Keeping &amp; Retention</h2>
      <p>The Firm maintains digital records of:</p>
      <ul>
        <li>Invoices, payments, receipts</li>
        <li>Client identity proofs</li>
        <li>Research reports & disclosures</li>
        <li>Communication with clients</li>
      </ul>
      <p>Records are retained for a minimum of 5 years or longer as directed by SEBI and other regulatory authorities from time to time.</p>

      <h2 class="mt-4 section-heading">14. Reporting of Suspicious Transactions</h2>
      <p>In the event of detection of fraudulent or suspicious activity, Grow With Stocks shall:</p>
      <ul>
        <li>Reject service activation or renewal</li>
        <li>Reverse/Refund payment if received</li>
        <li>Report the matter to FIU-IND (Financial Intelligence Unit – India) if legally mandated</li>
      </ul>

      <h2 class="mt-4 section-heading">15. Policy Review</h2>
      <p>This policy is reviewed annually or whenever regulatory changes occur.</p>
      <p>Updates are approved by the Principal Officer & Compliance Officer.</p>

      <h3 class="aml-subheading">Principal Officer Details</h3>
      <p>Name: Goutam Sharma<br>
      Designation: Principal Officer & Research Analyst<br>
      Grow With Stocks<br>
      SEBI Registration No. INH000001212<br>
      growwithstocks@gmail.com<br>
      +91-9271212131</p>
      <p>The Principal Officer is responsible for AML compliance, ongoing monitoring, and reporting suspicious transactions to FIU-IND as required under PMLA.</p>

      <h2 class="mt-4 section-heading">16. Declaration</h2>
      <p>Goutam Sharma, proprietor Grow With Stocks affirms strict compliance with PMLA, SEBI RA Regulations, and FIU-IND guidelines. The Firm does not support or engage in any activity facilitating money laundering, tax evasion, or illegal financial transactions.</p>
      <br>
    </div>
  </section>
</template>

<script>
export default {
  name: "AntiMoneyLaunderingPolicy",
  mounted() {
    document.title = "Anti-Money Laundering Policy | Grow With Stocks";
  }
};
</script>

<style lang="scss" scoped>
.grey_bg {
  min-height: 100vh;
  background: #f7f7f7;
  padding-bottom: 40px;
}
.page-title {
  font-size: 28px;
  font-weight: 700;
  color: #1a1a1a;
  text-align: center;
  margin-bottom: 24px;
  word-wrap: break-word;
}
.section-heading {
  font-size: 22px;
  font-weight: 700;
  color: #1a1a1a;
  margin-top: 28px;
  margin-bottom: 12px;
}
/* WCAG 1.3.1 — sub-clause h3 styled to match the original <b> visual weight
   while exposing the correct heading level (3) to assistive tech. */
.aml-subheading {
  font-size: 17px;
  font-weight: 700;
  color: #1a1a1a;
  margin-top: 20px;
  margin-bottom: 8px;
}
p {
  color: #2d2d2d;
  line-height: 1.6;
}
ul {
  margin-bottom: 12px;
}
li {
  margin-bottom: 6px;
  color: #2d2d2d;
  line-height: 1.5;
}
@media only screen and (max-width: 480px) {
  .page-title {
    font-size: 22px;
  }
  .section-heading {
    font-size: 18px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/AntiMoneyLaunderingPolicy.vue